<template>
  <span>
    <span v-if="isLoggedIn">
      <!-- <octicon name="sign-out" @click.native="logout"/> {{ username }} -->
      <router-link to="/logout" :event="''" @click.native.prevent="logout" title="تسجيل الخروج">
        <octicon name="sign-out"/>
      </router-link>
      <router-link to="/home">
        {{ username }}
      </router-link>
    </span>
    <span v-else>
      <!-- <octicon name="sign-in" @click.native="login"/> -->
      <router-link to="/login" :event="''" @click.native.prevent="login" title="تسجيل الدخول">
        <octicon name="sign-in"/>
      </router-link>
    </span>
    <firebase-auth-wrapper ref="authModal"/>
  </span>
</template>

<script>

import { auth } from './firebase.js'
import { signInAnonymously, signOut, onIdTokenChanged } from 'firebase/auth'

import Octicon from 'vue-octicon/components/Octicon.vue'
import 'vue-octicon/icons/sign-in'
import 'vue-octicon/icons/sign-out'

import FirebaseAuthWrapper from './FirebaseAuthWrapper'

export default {
  name: 'UserStatus',
  props: {
  },
  computed: {
    user: function () {
      return this.$store.state.user
    },
    isLoggedIn: function () {
      return this.user && !this.user.isAnonymous
    },
    username: function () {
      if (!this.isLoggedIn) { return null }
      return this.user.displayName || this.user.email || this.user.phone
    }
  },
  components: { FirebaseAuthWrapper, Octicon },
  methods: {
    login: function () {
      this.$refs.authModal.show()
    },
    logout: function () {
      signOut(auth).then(
        () => signInAnonymously(auth))
    },
    onIdTokenChanged: function (user) {
      this.$store.commit('updateUser', user)
    }
  },
  created: function () {
    onIdTokenChanged(auth, this.onIdTokenChanged)
  }
}
</script>

<style scoped>
</style>
